// For additional target names see:
// https://www.gateworld.net/wiki/Category:Planets
export class StargateConstants {
  static readonly TARGET_A: string = 'Abydos';
  static readonly TARGET_B: string = 'Belkan';
}
